import { useQuery } from '@apollo/client';

import { graphql } from '@eluve/graphql.tada';

export const tenantNameFragment = graphql(`
  fragment TenantName on Tenants @_unmask {
    __typename
    id
    name
  }
`);

export const getTenantNameQuery = graphql(
  `
    query getTenantName($tenantId: uuid!) {
      tenantsByPk(id: $tenantId) {
        ...TenantName
      }
    }
  `,
  [tenantNameFragment],
);

export const useTenantName = (tenantId: string) => {
  const { data } = useQuery(getTenantNameQuery, {
    fetchPolicy: 'cache-first',
    variables: { tenantId },
  });

  return data?.tenantsByPk?.name ?? '';
};
